import { render } from "./SearchDrawer.vue?vue&type=template&id=faf67ff2&scoped=true"
import script from "./SearchDrawer.vue?vue&type=script&lang=js"
export * from "./SearchDrawer.vue?vue&type=script&lang=js"

import "./SearchDrawer.vue?vue&type=style&index=0&id=faf67ff2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf67ff2"]])

export default __exports__